interface ProviderMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
}

const ProviderMenu: React.FC<ProviderMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={78}
            checked={!clear && displayValue === 78}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Cardiologist</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={79}
            checked={!clear && displayValue === 79}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Internal Medicine
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={80}
            checked={!clear && displayValue === 80}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Surgery or Critical Care
          </span>
        </label>
      </li>
    </ul>
  );
};

export default ProviderMenu;
